import React from 'react';
import { useAuth } from '../../context/AuthContext';
import perfilImg from '../../assets/images/perfil.png'; // Asumiendo que aún se usa la imagen de perfil
import { FaWhatsapp, FaCalendarAlt, FaStar, FaBrain, FaHeart, FaLeaf, FaSun, FaLightbulb, FaBookOpen, FaHandsHelping, FaSpa, FaChalkboardTeacher } from "react-icons/fa";
import { GiMeditation, GiWindpump, GiBrain, GiMountainRoad } from "react-icons/gi"; // Más iconos para los tipos de masterclass

const theoreticalMasterclasses = [
  "Las 5 Leyes Universales",
  "Las 7 Leyes del Kybalion",
  "Realidades Paralelas",
  "El Camino de Menor Resistencia",
  "Mente Superior y Mente Física",
  "Los 9 Niveles de Conciencia",
  "Niveles de Fuerza y Poder",
  "Ley de Resonancia, Espejo & Atracción",
];

const practicalMasterclasses = [
  "Respiración Consciente",
  "Pranayamas Avanzados",
  "Método Wim Hof: Respiración y Frío",
  "Método Joe Dispenza: Meditación y Activación Cuántica",
  "Método Vishen Lakiani: Fases de Visualización",
  "Meditación Guiada y Visualización Creativa",
  "Activación de la Glándula Pineal"
];

const InViewSection = ({ title, children, index, id }) => (
  <section
    id={id}
    className="w-full max-w-lg mx-auto mb-12 p-6 rounded-xl border border-gray-700 bg-black/40 shadow-xl shadow-gray-900/50 fade-in-up"
    style={{ animationDelay: `${index * 150 + 700}ms` }}
  >
    <h3 className="text-2xl font-bold mb-5 text-center text-purple-300 border-b border-gray-700 pb-3">{title}</h3>
    {children}
  </section>
);

const CTAButtonsSubscription = ({ delay }) => (
  <div
    className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 w-full max-w-md fade-in-up"
    style={{ animationDelay: `${delay}ms` }}
  >
    <a
      href={`https://wa.me/5491150254270?text=${encodeURIComponent("Hola Gustavo, quiero suscribirme a las Masterclasses Mensuales.")}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center px-7 py-3 rounded-xl border border-purple-600 bg-purple-700/60 text-white font-bold text-lg shadow-lg shadow-purple-700/40 hover:bg-purple-600 hover:scale-105 transition-all duration-300 ease-in-out w-full sm:w-auto"
    >
      <FaWhatsapp className="mr-3 text-2xl" /> ¡Quiero suscribirme ahora!
    </a>
  </div>
);

const MasterclassSubscriptionPage = () => {
  const { user } = useAuth();

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col relative overflow-hidden">
      <div className="fixed inset-0 bg-gradient-to-br from-gray-950 via-black to-gray-900 opacity-95 z-0 animate-gradient-shift"></div>
      <style>
        {`
        @keyframes gradient-shift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-shift {
          background-size: 200% 200%;
          animation: gradient-shift 15s ease infinite;
        }
        .fade-in-up {
          animation-fill-mode: both;
          animation-duration: 0.8s;
          animation-name: fade-in-up-keyframes;
          opacity: 0;
          transform: translateY(20px);
        }
        @keyframes fade-in-up-keyframes {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        `}
      </style>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        {/* HERO */}
        <h1
          className="text-4xl sm:text-6xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-purple-300 via-purple-400 to-purple-500 text-center leading-tight fade-in-up"
          style={{ animationDelay: '100ms' }}
        >
          Masterclasses Mensuales
        </h1>

        <p
          className="text-2xl sm:text-4xl text-gray-100 text-center max-w-2xl mb-5 font-light fade-in-up"
          style={{ animationDelay: '250ms' }}
        >
          Expande tu Conciencia y Potencia tu Manifestación.
        </p>

        <p
          className="text-lg sm:text-xl text-gray-400 text-center max-w-xl mb-12 fade-in-up"
          style={{ animationDelay: '400ms' }}
        >
          Acceso ilimitado a conocimiento profundo y prácticas transformadoras por solo <span className="text-purple-300 font-bold">$17 USD/mes</span>.
        </p>
        
        <div className="w-full max-w-lg mx-auto mb-12 flex justify-center">
          <CTAButtonsSubscription delay={500} />
        </div>

        {/* Qué incluye */}
        <InViewSection title="¿Qué incluye tu suscripción?" index={0} id="incluye">
          <ul className="list-none pl-0 text-gray-300 space-y-3">
            <li className="flex items-center">
              <FaChalkboardTeacher className="text-purple-400 mr-3 text-xl flex-shrink-0" />
              <span>Acceso a <span className="font-semibold text-purple-300">3 nuevas Masterclasses al mes</span> (teóricas y prácticas).</span>
            </li>
            <li className="flex items-center">
              <FaBookOpen className="text-purple-400 mr-3 text-xl flex-shrink-0" />
              <span>Material de apoyo exclusivo y guías descargables.</span>
            </li>
            <li className="flex items-center">
              <FaSpa className="text-purple-400 mr-3 text-xl flex-shrink-0" />
              <span>Sesiones de preguntas y respuestas en vivo (Q&A) con Gustavo Aguiar.</span>
            </li>
            <li className="flex items-center">
              <FaHeart className="text-purple-400 mr-3 text-xl flex-shrink-0" />
              <span>Comunidad exclusiva para compartir experiencias y aprendizajes.</span>
            </li>
            <li className="flex items-center">
              <FaCalendarAlt className="text-purple-400 mr-3 text-xl flex-shrink-0" />
              <span>Grabaciones disponibles para ver en cualquier momento.</span>
            </li>
          </ul>
        </InViewSection>

        {/* Masterclasses Teóricas */}
        <InViewSection title="Temas teóricos que exploraremos" index={1} id="teoricas">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-200">
            {theoreticalMasterclasses.map((topic, i) => (
              <div key={i} className="flex items-center bg-gray-900/30 p-3 rounded-lg shadow-inner">
                <FaBrain className="text-yellow-300 mr-3 text-lg flex-shrink-0" />
                <span>{topic}</span>
              </div>
            ))}
          </div>
        </InViewSection>

        {/* Masterclasses Prácticas */}
        <InViewSection title="Prácticas para tu evolución" index={2} id="practicas">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-gray-200">
            {practicalMasterclasses.map((topic, i) => (
              <div key={i} className="flex items-center bg-gray-900/30 p-3 rounded-lg shadow-inner">
                <GiMeditation className="text-green-300 mr-3 text-lg flex-shrink-0" />
                <span>{topic}</span>
              </div>
            ))}
          </div>
        </InViewSection>

        {/* CTA intermedia */}
        <div className="w-full max-w-lg mx-auto mb-12 flex justify-center">
          <CTAButtonsSubscription delay={1200} />
        </div>

        {/* Para quién es */}
        <InViewSection
          title={
            <span className="flex items-center justify-center gap-2">
              <FaStar className="text-purple-500 text-2xl" />
              <span>Esta suscripción es para ti si...</span>
            </span>
          }
          index={3}
          id="para-quien"
        >
          <ul className="list-none pl-0 text-gray-200 space-y-2">
            <li><span className="text-purple-400 mr-2 text-lg">✔</span> Quieres un crecimiento constante y sostenido.</li>
            <li><span className="text-purple-400 mr-2 text-lg">✔</span> Buscas profundizar en las leyes universales y la metafísica.</li>
            <li><span className="text-purple-400 mr-2 text-lg">✔</span> Deseas integrar prácticas de bienestar en tu día a día.</li>
            <li><span className="text-purple-400 mr-2 text-lg">✔</span> Valoras el acceso a contenido exclusivo y una comunidad de apoyo.</li>
            <li><span className="text-purple-400 mr-2 text-lg">✔</span> Estás comprometido/a con tu evolución personal.</li>
          </ul>
        </InViewSection>

        {/* Testimonial (si tuvieras algunos específicos para masterclasses) */}
        {/* <InViewSection title="Lo que dicen nuestros suscriptores" index={4} id="testimonios">
          <div className="space-y-6">
             <blockquote className="border-l-4 border-purple-400 pl-4 italic text-gray-200 bg-gray-900/30 p-4 rounded-lg shadow-inner">
              “Las masterclasses de Gustavo son un antes y un después en mi comprensión de la vida.”
              <span className="block text-gray-400 mt-2 not-italic font-medium">– Sofía G., Coach Espiritual</span>
            </blockquote>
          </div>
        </InViewSection> */}

        {/* Precio Final */}
        <InViewSection title="Tu inversión en expansión" index={5} id="precio">
            <div className="text-center">
                <p className="text-5xl font-extrabold text-purple-300 mb-4">
                    $17 <span className="text-2xl text-gray-400">USD / mes</span>
                </p>
                <p className="text-lg text-gray-300 mb-6">
                    Acceso ilimitado a todo el contenido y la comunidad.
                    Cancela en cualquier momento.
                </p>
                <CTAButtonsSubscription delay={1500} />
            </div>
        </InViewSection>

      </main>

      {/* FOOTER */}
      <footer
        className="relative z-10 text-center py-8 text-xs text-gray-500 bg-black/50 border-t border-gray-800 fade-in-up"
        style={{ animationDelay: '1800ms' }}
      >
        <p>© {new Date().getFullYear()} Gustavo Aguiar | En misión de elevar y transformar.</p>
        <p className="mt-1">Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default MasterclassSubscriptionPage;